<template>
  <div>
    <div class="py-6 primary">
      <div
        v-if="metalsIsError"
        class="d-flex justify-center align-center"
      >
        <error-alert
          :message.sync="metalsIsError"
          noMargin
        ></error-alert>
        <edit-metal-prices-widget
          addIcon
          v-if="isAdmin"
        ></edit-metal-prices-widget>
      </div>

      <!-- mobile design -->
      <div
        class="d-flex px-3"
        v-else-if="$vuetify.breakpoint.mobile"
        @click="pricesDropdownMobileOpen = !pricesDropdownMobileOpen"
      >
        <div class="flex-grow-1 font-weight-bold white--text">
          Market Price
        </div>
        <v-icon class="white--text">{{ pricesDropdownMobileOpen ? 'mdi-menu-down' : 'mdi-menu-right'}}</v-icon>
      </div>

      <!-- desktop design -->
      <div v-else>
        <div class="d-flex hidden-md-and-down justify-center align-center">
          <div class="font-weight-bold mr-4">
            Market Price:
          </div>
          <v-chip
            class="mr-4"
            color="secondary"
            label
            dark
          >Platinum - {{metalPrice('platinum')}}</v-chip>
          <v-chip
            class="mr-4"
            color="secondary"
            label
            dark
          >Palladium - {{metalPrice('palladium')}}</v-chip>
          <v-chip
            class="mr-4"
            color="secondary"
            label
            dark
          >Rhodium - {{metalPrice('rhodium')}}</v-chip>

          <edit-metal-prices-widget v-if="isAdmin"></edit-metal-prices-widget>

        </div>
        <div
          v-if="metals && metals.is_manual"
          class="d-flex error--text font-weight-bold justify-center align-center mt-1 text-subtitle-2"
        >
          Prices are Locked
        </div>
        <div
          v-if="metals && metals.updated_at"
          class="d-flex justify-center align-center mt-1 text-subtitle-2"
        >Updated at: {{metals.updated_at.toLocaleString()}}</div>
      </div>
    </div>

    <!-- part of mobile UI -->
    <v-expand-transition>
      <v-list
        class="py-0"
        v-show="!metalsIsError && pricesDropdownMobileOpen"
      >
        <v-list-item class="secondary lighten-2">
          <v-list-item-title class="white--text">Platinum - {{metalPrice('platinum')}}</v-list-item-title>
        </v-list-item>
        <v-list-item class="secondary">
          <v-list-item-title class="white--text">Palladium - {{metalPrice('palladium')}}</v-list-item-title>
        </v-list-item>
        <v-list-item class="secondary lighten-2">
          <v-list-item-title class="white--text">Rhodium - {{metalPrice('rhodium')}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-expand-transition>
  </div>
</template>
<script>
import { mapState } from "@/store/modules/preciousMetals";
import { mapGetters as rootMapGetters } from "vuex";
import EditMetalPricesWidget from "./EditMetalPricesWidget.vue";

export default {
  data: () => ({
    pricesDropdownMobileOpen: false,
  }),
  components: { EditMetalPricesWidget },
  computed: {
    ...mapState({
      metals: (state) => state.data,
      metalsIsError: (state) => state.error,
    }),
    ...rootMapGetters("user", ["isAdmin"]),
  },
  methods: {
    metalPrice(metalName) {
      if (this.metals && this.metals[metalName]) {
        return "$" + this.metals[metalName] + " USD";
      }
      return "Loading...";
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-chip__content {
    justify-content: center;
    padding: 8px;
  }
}
</style>